import { AggregationType } from "types/charts";

export enum UsageMetrics {
  TRANSACTIONS = "transactions",
  BILLABLE_MEMBERS = "billableMembers",
}

export type UsageMetricsUnion = `${UsageMetrics}`;

export enum GlobalOverviewMetrics {
  REGISTERED_MEMBERS = "registeredMembers",
  ACTIVE_MEMBERS = "activeMembers",
  TRANSACTIONS = "transactions",
  AVG_NUMBER_OF_TRANSACTIONS = "avgNumberOfTransactions",
}

export type GlobalOverviewMetricsUnion = `${GlobalOverviewMetrics}`;

type DataHeader = {
  [Property in GlobalOverviewMetricsUnion]: number;
};

export type GlobalOverviewData = {
  aggregationType: AggregationType;
  intervalStartDate: string;
  intervalEndDate: string;
  dataType: DataHeader;
  header: DataHeader;
  data: {
    [key: string]: number;
  };
};
